import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Awards from 'components/BKantarciAwards/Awards';
import { useEffect } from "react";

function ResearchAwards() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar /> 
        <Awards/>
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Awards/>
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ResearchAwards;
